import Vue from "vue";
import App from "./App.vue";
import store from "./stores/index.js";
import router from "./router/index.js";
import apis from "./apis/index.js";
import "reset-css";

Vue.config.productionTip = false;
Vue.use(apis);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
